import React from 'react';

import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar'

import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6

import Indicators from '../../indicators/containers/Indicators' //Consider transferring to routes
//import Indicators from '../../indicators/containers/CheckboxIndicators'

//onChange={content =>handleTextChange(content.data,selectedActivity.id,item.id,selectedAssessment)}

/**
 * Note: Performance degradation with DOM mutation events https://github.com/quilljs/quill/issues/1768
        onDismiss={ log('test') }
        dismissButtonAriaLabel='Close'
        errorMessage.message.code
 */
export default ({items, handleTextOnChange, findText, selectedAssessment,selectedActivity, errorMessage}) => (

    <div className="ms-Grid">
    {items ? items.map( (item,i) => 
      <div key={i} className="ms-Grid-row">
        <div className="ms-Grid-col ms-lg12"><hr /></div>
        <div  className="ms-Grid-col ms-lg3" ><strong>{item.name} </strong> {item.description} </div>
        <Indicators levelId={item.id} items={item.indicators}/>
        <div className="ms-Grid-col ms-lg12">
        <ReactQuill
            defaultValue={findText(selectedAssessment.answers,selectedActivity.id,item.id)} 
          onChange={(content, delta, source, editor) =>
                  handleTextOnChange(content, delta, source, editor,item.id)}
              />
        {errorMessage && errorMessage.levelId === item.id 
            ? <MessageBar
            messageBarType={ MessageBarType.error }
            isMultiline={ false }>
            There was a problem saving your answer
            </MessageBar>
            : ''}
        </div>
       </div>) :  <span>Loading</span>}
    </div>
    
)



// WEBPACK FOOTER //
// ./src/levels/components/Levels.js